export default {
    keys: {
        id: 'id',
        theme: 'thema.id',
        region: 'regio.id',
        author: 'auteur.id',
        period: 'tijdvak.id',
        organization: 'organisatie.id',
    },
    operators: {
        in: 'In',
        equals: 'Eq',
        lowerThan: 'Lt',
        greaterThan: 'Gt',
        notIn: 'NotEq',
    },
    inputTypes: {
        checkboxes: 'checkboxes',
        select: 'select',
        radio: 'radio',
    },
    queryParams: {
        page: 'page',
        text: 'text',
    },
    cookies: {
        blockMapView: 'blockMapView',
    },
    magicStrings: {
        queryCount: '{{queryCount}}',
        totalCount: '{{totalCount}}',
    },
    maps: {
        zoomLevels: {
            mobile: 8,
            tablet: 9,
            desktop: 10,
            widescreen: 11,
        },
        coordinates: {
            utrecht: {
                lat: 52.0919,
                lng: 5.1230,
            },
        },
    },
    images: {
        modes: {
            fullwidth: 'fullwidth',
            image: 'image',
            normal: 'normal',
        },
    },
    radio: {
        maxOptions: 5,
    },
    classes: {
        tags: {
            tiffanyBlue: 'is-primary',
        }
    },
    labels: {
        story: {
            minutes: 'min',
        },
        activity: {
            startEndDateSeparator: ' t/m ',
        }
    },
    breakpoints: {
        mobile: 768,
        tablet: 1024,
    },
}